var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loading',{attrs:{"active":_vm.getLoading,"can-cancel":true,"is-full-page":true}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }